// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

export default css`
  .pill-click.ratings {
    display: flex;
    .input-radio-title {
      border: 4px solid ${(props) => props.theme.colors.WHITE};
      display: flex;
      flex: 1;
      justify-content: center;
      align-items: center;
      text-transform: uppercase;
      color: ${(props) => props.theme.colorPalette.gray[900]};
      border-radius: 10px;
      text-align: center;
      width: 6px;
      height: 6px;
      letter-spacing: 0.42px;
      padding: 2px;
      font-family: 'Nunito';
      margin: 0;
      outline: solid 1px ${(props) => props.theme.colorPalette.gray[900]};
      font-size: ${(props) => props.theme.fonts.fontSize.body.bodytext.copy2}px;
      min-width: unset;
    }
  }
  .rating-filter {
    margin-left: 10px;
  }
  .post-rating-text {
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-size: ${(props) => props.theme.typography.fontSizes.fs14};
    margin-left: 10px;
    text-transform: capitalize;
  }
 
  .size-and-fit-detail-item::-webkit-scrollbar {
    display: none;
  }
`;
